import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { authApi } from "@/services/api";
import authReducer from "./auth/slice";
import userReducer from "./user/slice";
import facilityReducer from "./facility/slice";
import rolePermissionReducer from "./role-and-permission/slice";
import patientReducer from "./patient/slice";
import addedPatientInfoReducer from "./patient/addedPatientInfoSlice";
import projectReducer from "./project/slice";
import deviceModelReducer from "./device/deviceModelSlice";
import deviceAdminReducer from "./device/deviceAdminSlice";
import dataRequestReducer from "./data-request/slice";
import medicineReducer from "./medicine/slice";
import dashboardReducer from "./home/slice";
import accessoryReducer from "./accessories/slice";
import userSliceViewReducer from "./user/viewUserSlice";
import authMiddleware from "./auth/middleware";
import alertReducer from "./alert-management/slice";
import notificationReducer from "./notification/slice";
import monitoringReducer from "./project/monitoringSlice";
import parameterUnitReducer from "./clinical-parameters-unit/slice";
import clinicalParameterReducer from "./clinical-parameters/slice";
import clinicianDiseaseReducer from "./project/clinicianDiseaseSlice";
import feedbackReducer from "./feedback/slice";
import teleconsultationReducer from "./teleconsultation/slice";
import useUserAcceptanceReducer from "./user-acceptance/slice";
import noteReducer from "./note/slice";

const store = configureStore({
    reducer: {
        [authApi.reducerPath]: authApi.reducer,
        auth: authReducer,
        user: userReducer,
        userView: userSliceViewReducer,
        facility: facilityReducer,
        rolePermission: rolePermissionReducer,
        patient: patientReducer,
        addedPatientInfo: addedPatientInfoReducer,
        project: projectReducer,
        deviceModel: deviceModelReducer,
        deviceAdmin: deviceAdminReducer,
        dataRequest: dataRequestReducer,
        medicine: medicineReducer,
        dashboard: dashboardReducer,
        accessory: accessoryReducer,
        alert: alertReducer,
        notification: notificationReducer,
        monitoring: monitoringReducer,
        parameterUnit: parameterUnitReducer,
        clinicianDisease: clinicianDiseaseReducer,
        feedback: feedbackReducer,
        consultation: teleconsultationReducer,
        userAcceptance: useUserAcceptanceReducer,
        clinicalParameter: clinicalParameterReducer,
        note: noteReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(authApi.middleware).concat(authMiddleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
